import React from "react";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

const ADDRESS_FIELDS = [
  "address1",
  "address2",
  "city",
  "state",
  "zipCode",
  "country",
];

export const isSameAddress = (a, b) =>
  ADDRESS_FIELDS.every((key) => (a?.[key] || "") === (b?.[key] || ""));

const AddressBlock = ({
  icon,
  title,
  address,
  badge,
  action,
  showName = true,
}) => {
  const name = [address?.firstName, address?.lastName]
    .filter(Boolean)
    .join(" ");
  const lines = [
    [address?.address1, address?.address2].filter(Boolean).join(", "),
    [address?.city, address?.state, address?.zipCode].filter(Boolean).join(" "),
    address?.country,
  ].filter(Boolean);

  return (
    <div className="checkout-address-card">
      <div className="checkout-address-card-header">
        <span className="checkout-address-card-icon">{icon}</span>
        <span className="checkout-address-card-title">{title}</span>
        {badge && (
          <span className="checkout-address-card-badge">
            <CheckCircleOutlineIcon />
            {badge}
          </span>
        )}
        {action && (
          <span className="checkout-address-card-action">{action}</span>
        )}
      </div>
      {showName && name && (
        <div className="checkout-address-card-name">{name}</div>
      )}
      <div className="checkout-address-card-line">
        <PlaceOutlinedIcon fontSize="small" />
        <span>
          {lines.map((line, i) => (
            <span key={i} className="d-block">
              {line}
            </span>
          ))}
        </span>
      </div>
      {address?.contactNo && (
        <div className="checkout-address-card-line">
          <PhoneOutlinedIcon fontSize="small" />
          <span>{address.contactNo}</span>
        </div>
      )}
    </div>
  );
};

export default AddressBlock;
